import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import templates from "../../utils/templates";
import Search from "./Search";
import Card from "./Card";
import classes from "./Templates.module.css";

const Templates = (props) => {
  const [expanded, setExpanded] = useState(false);
  const [categoryTrigger, setCategoryTrigger] = useState(false);
  const [validCategories, setValidcategories] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [validTemplates, setValidTemplates] = useState(templates);

  /**
   *
   * @param {string} currentSearchTerm
   * @param {array} allValidCategories
   * @returns valid templates
   */
  const doSearch = (currentSearchTerm, allValidCategories) => {
    let validCategoryTemplates = [];
    let validTemplates = [];

    if ((allValidCategories.length = 1)) {
      // template which belong to selected category
      allValidCategories.forEach((validCategory) => {
        templates.forEach((template) => {
          if (validCategory.value === template.category) {
            validCategoryTemplates.push(template);
          }
        });
      });
    } else {
      validCategoryTemplates = templates;
    }

    if (currentSearchTerm.length > 2) {
      validTemplates = validCategoryTemplates.filter((template) => {
        const templateLabel = template.label;
        const newTemplateLabel = templateLabel.toLowerCase();
        if (
          newTemplateLabel.indexOf(currentSearchTerm) !== -1 ||
          template.category.indexOf(currentSearchTerm) !== -1
        ) {
          return true;
        }
        return false;
      });
    } else {
      validTemplates = validCategoryTemplates;
    }

    return validTemplates;
  };

  /**
   *
   * @param {panel1/true} panel
   * @returns open and close accordian on click depending on previous state
   */
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  //close accordian after template is selected
  const closePanel = () => {
    setExpanded(false);
  };

  const searchHandler = (event) => {
    setSearchTerm(event.target.value);
    const searchValue = event.target.value.toLowerCase().trim();

    let allValidTemplates = doSearch(searchValue, validCategories);
    setValidTemplates(allValidTemplates);
  };

  // const categoriesChangeHandler = (categories) => {
  //   setValidcategories(categories);
  //   let allValidTemplates = doSearch(searchTerm, categories);

  //   setValidTemplates(allValidTemplates);
  // };

  /**
   * display all valid templates in accordian
   */
  const allTemplates = validTemplates.map((template) => {
    return (
      <Card
        key={template.id}
        template={template}
        updateTemplate={props.updateTemplate}
        closePanel={closePanel}
        activeTemplateId={props.activeTemplateId}
      />
    );
  });

  // displays when there is no valid template
  const emptyDiv = () => {
    return <div className={classes.result}>No Result Found</div>;
  };

  var displayLabel = "Select Template";
  templates.forEach((item) => {
    if (props.activeTemplateId === item.id) {
      displayLabel = item.label;
    }
  });

  // const selectData = templateCategories.map((category) => {
  //   return { value: category.id, label: category.label };
  // });

  if (props.trigger !== categoryTrigger) {
    const allValidCategories = [];
    // templateCategories.forEach((templateCategory) => {
    //   if (templateCategory.includedTriggers.indexOf(props.trigger) !== -1) {
    //     let validCategory = { ...templateCategory, value: templateCategory.id };
    //     allValidCategories.push(validCategory);
    //   }
    // });
    templates.forEach((template) => {
      if (template.category.indexOf(props.trigger) !== -1) {
        let validCategory = { ...template, value: template.category };
        allValidCategories.push(validCategory);
      }
    });

    let allValidTemplates = doSearch(searchTerm, allValidCategories);
    setValidcategories(allValidCategories);
    setValidTemplates(allValidTemplates);
    setCategoryTrigger(props.trigger);
    setExpanded("panel1");
  }

  return (
    <div className={classes.main}>
      <div className={classes.labelInfo}>
        <label>Template</label>
      </div>
      <div
        className={classes.formInputContainer}
        style={{ marginBottom: "20px" }}
      >
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            expandIcon={<ExpandMoreIcon />}
          >
            {" "}
            {displayLabel}
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.searchFlex}>
              <Search onSearch={searchHandler} value={searchTerm} />
              {/* <div className={classes.templateFilterSearch}>
                <div className={classes.labelInfo}>
                  <label>Select Category</label>
                </div>
                <Select
                  options={selectData}
                  value={validCategories}
                  onChange={categoriesChangeHandler}
                  isMulti
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                ></Select>
              </div> */}
            </div>

            <div className={classes.main}>
              {validTemplates.length ? allTemplates : emptyDiv()}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default Templates;
